<script lang="ts">
    import { connection } from "../lib/connection.svelte.ts";
    import { commandInput } from "../lib/commandInput.svelte.ts";
    import { messages } from "../lib/messages.svelte.ts";
    import NarrativeEntry from "./NarrativeEntry.svelte";

    let outputEl: HTMLDivElement;
    let atBottom = true;

    function onScroll() {
        const el = outputEl;
        if (!el) return;
        const distFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
        atBottom = distFromBottom < 40;
    }

    $effect(() => {
        const _ = messages.entries.length;
        if (atBottom && outputEl) {
            requestAnimationFrame(() => {
                outputEl.scrollTop = outputEl.scrollHeight;
            });
        }
    });

    // ── Exit-link click delegation ─────────────────────────────────────────
    // Clicks on <a> elements that aren't external links invoke the command.
    function onClick(e: MouseEvent) {
        const a = (e.target as Element).closest("a");
        if (!a) return;

        // autoLink() marks externals with this class — let them open normally.
        if (a.classList.contains("moo-link-external")) return;

        e.preventDefault();
        e.stopPropagation();

        const href = a.getAttribute("href") ?? "";
        let cmd: string;
        if (href.startsWith("moo://cmd/")) {
            cmd = decodeURIComponent(href.slice("moo://cmd/".length));
        } else if (href && !href.startsWith("moo://")) {
            // Plain href (relative path or bare command text)
            cmd = href;
        } else {
            cmd = (a.textContent ?? "").trim();
        }
        if (cmd) connection.send(cmd);
    }

    // ── Object right-click delegation ──────────────────────────────────────
    // Elements tagged data-objid by the server get a verb context menu.
    function onContextMenu(e: MouseEvent) {
        const el = (e.target as Element).closest("[data-objid]");
        if (!el) return;

        e.preventDefault();
        commandInput.openContextMenu(
            e.clientX,
            e.clientY,
            el.getAttribute("data-objid"),
            el.textContent?.trim() ?? "object",
        );
    }
</script>

<div
    class="output-window"
    bind:this={outputEl}
    onscroll={onScroll}
    onclick={onClick}
    oncontextmenu={onContextMenu}
    role="log"
    aria-live="polite"
    aria-label="MOO output"
>
    {#each messages.entries as msg (msg.id)}
        <NarrativeEntry {msg} />
    {/each}
</div>

<style>
    .output-window :global(a) {
        cursor: pointer;
        text-decoration: underline;
    }

    .output-window {
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
        background: rgba(10, 8, 5, 0.72);
        border: 1px solid rgba(90, 72, 45, 0.28);
        padding: 0.8rem 1rem;
        font-family: 'Courier New', Courier, monospace;
        font-size: 0.875rem;
        line-height: 1.55;
        color: #c8c0a4;
    }
</style>
